import Add from '@mui/icons-material/Add';
import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { INftForm } from 'interfaces/NftData.interface';
import { IOtrForm } from 'interfaces/OtrData.interface';
import { SetStateAction, useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';

const thumbsContainer: any = {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  width: 'fit-content',
  overflow: 'hidden',
};

const thumb: React.CSSProperties = {
  position: 'relative',
  display: 'inline-flex',
  borderRadius: 2,
  border: '1px solid #eaeaea',
  width: 'fit-content',
  padding: 2,
  boxSizing: 'border-box',
};

const thumbInner = {
  display: 'flex',
  minWidth: 0,
  overflow: 'hidden',
};

const img: any = {
  display: 'block',
  width: '345px',
  height: '345x',
};

const ImgageAreaBox = styled(Button)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  backgroundColor: 'rgba(255,255,255,0.09803921568627451 )',
  width: '103px',
  height: '103px',
  borderRadius: '10px',
  border: 'solid',
  borderColor: '#ffffff',
  borderWidth: '1px',
  '&:hover': {
    backgroundColor: 'rgba(255,255,255,0.09803921568627451 )',
  },
}));
declare global {
  interface HTMLElement {
    src: string;
  }
}

interface IDropZone {
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  getFiles?: (file: File) => void;
  form: INftForm | IOtrForm;
  setForm: SetStateAction<any>;
}

function DropZoneCards({ onChange, getFiles, form, setForm }: IDropZone) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [files, setFiles] = useState<any[]>([]);
  const { getRootProps, getInputProps } = useDropzone({
    accept:
      'image/jpeg,image/png,image/gif,image/svg,video/mp4,audio/mp3,audio/wav,audio/ogg',
    onDrop: acceptedFiles => {
      setIsLoaded(true);
      setFiles(
        acceptedFiles.map(file =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
    },
  });

  const preview = files.length && (
    <div style={thumb}>
      <video
        src={files[0].preview}
        id="preview-video"
        style={{ position: 'absolute', visibility: 'hidden' }}
      ></video>
      <div style={thumbInner}>
        <video
          autoPlay
          muted
          src={files[0].preview}
          poster={files[0].preview}
          style={img}
          id="video"
        ></video>
      </div>
    </div>
  );

  useEffect(() => {
    if (files[0] && getFiles) {
      getFiles(files[0]);
    }
    //eslint-disable-next-line
  }, [files]);

  return (
    <section>
      <div {...getRootProps({ className: 'dropzone' })}>
        <input
          title="image"
          name="image"
          type="file"
          onChange={onChange}
          {...getInputProps()}
        />
        {isLoaded ? (
          <aside style={thumbsContainer}>{preview}</aside>
        ) : (
          <ImgageAreaBox
            endIcon={
              <Add
                style={{
                  fontSize: '40px',
                  color: '#36899f',
                  position: 'absolute',
                  left: '30px',
                  top: '30px',
                }}
              />
            }
          />
        )}
      </div>
    </section>
  );
}

export default DropZoneCards;
